<template>
  <div class="banner-verbal-identity-image-content">
    <div class="banner-image" :style="{ backgroundImage: `url(${bannerImageSrc})` }"></div>
    <div class="overlay-image">
      <h1 class="banner-title">{{ bannerImageTitle }}</h1>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import VerbalIdentityPageMixin from '@/mixins/verbal-identity-page-mixin'
import { VerbalIdentityPageStore } from '@/store/verbal-identity-page/verbal-identity-store'


@Component({})
export default class BannerVerbalIdentityImageSection extends Mixins(VerbalIdentityPageMixin) {
  verbalIdentityPageStore: PageStoreContract = getModule(VerbalIdentityPageStore, this.$store)

  get bannerImageTitle(): string {
    return this.getElementTitle(0, 0)
  }

  get bannerImageSrc(): string {
    return this.getElementMedia(0, 0)
  }

  async getVerbalIdentityPage(): Promise<void> {
    await this.verbalIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.verbalIdentityPageStore.isLoading) {
      await this.getVerbalIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.banner-verbal-identity-image-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: gray;
  width: 100% !important;
  max-height: 28rem;
}

.banner-image {
  position: relative;
  width: 100%;
  height: 451px;

  background-size: cover;

  background-repeat: no-repeat;
  background-position: center;
}

.overlay-image {
  position: absolute;
  bottom: 5.5rem;
  left: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  z-index: 1;
  pointer-events: none;
  text-align: left;
}

.banner-title {
  font-size: 8rem;
  width: 1rem;
  margin: 0;
  font-weight: 400;
  line-height: 7.25rem;
  letter-spacing: -0.01em;
  text-align: left;

}

@media (min-width: 1726px) {
  .banner-verbal-identity-image-content {
    width: 100%;
  }
}
</style>
